import { motion } from "framer-motion";
import { DollarSign, Bot, MessageCircle, FileText } from "lucide-react";

const features = [
  {
    icon: DollarSign,
    title: "El más accesible",
    description: "$350/mes vs $749+ de la competencia. Mismo servicio, precio justo.",
    highlight: "$350/mes",
  },
  {
    icon: Bot,
    title: "Potenciado por IA",
    description: "Nuestro asistente inteligente clasifica tus facturas y optimiza deducciones automáticamente.",
    highlight: "Automático",
  },
  {
    icon: MessageCircle,
    title: "Humano cuando lo necesitas",
    description: "Chat con tu contador asignado por WhatsApp. Respuesta en minutos, no días.",
    highlight: "WhatsApp",
  },
  {
    icon: FileText,
    title: "Factura fácilmente",
    description: "Genera facturas a tus clientes desde nuestro sistema en segundos. Sin complicaciones.",
    highlight: "Incluido",
  },
];

export function WhySection() {
  return (
    <section className="section-padding">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4">
            ¿Por qué <span className="gradient-text">SinConta</span>?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Combinamos tecnología de punta con atención humana para ofrecerte el mejor servicio contable de México.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
          {features.map((feature, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card-hover p-5 sm:p-6 lg:p-8 text-center"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 mx-auto mb-4 lg:mb-6 rounded-xl lg:rounded-2xl bg-secondary/10 flex items-center justify-center">
                <feature.icon className="w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 text-secondary" />
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-accent/10 text-accent text-xs sm:text-sm font-medium mb-3 lg:mb-4">
                {feature.highlight}
              </div>
              <h3 className="text-lg sm:text-xl font-heading font-bold mb-2 lg:mb-3">{feature.title}</h3>
              <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
